<template>
    <b-col :cols="expandGraphs ? '12' : '6'" class="d-flex justify-content-between">
        <b-card class="mb-0 five9-graphs-cards expand-card" :class="expandGraphs ? 'expand-graph' : '' " style="min-height:200px" v-b-visible="mountedAction">
            <template v-slot:header>
                <span class="h6"><i class="fa-duotone fa-chart-line-down mr-1"></i>  Time To Offergen</span>
            </template>
            <b-row>
                <b-col sm="5">
                    <vc-date-picker v-model="dateRange" :popover="datePickerProps" is-range class="" :model-config="modelConfig">
                        <template v-slot="{ inputValue, inputEvents }">
                            <b-row class="no-gutters">
                                <b-col>
                                    <div class="text-center form-control" v-on="loading ? null : inputEvents.start" :disabled="loading">
                                        {{ dateRange.start | date }}{{ dateRange.start ? '': 'mm-dd-yyyy' }} - {{ dateRange.end | date }}{{ dateRange.end ? '': 'mm-dd-yyyy' }}
                                    </div>
                                </b-col>
                            </b-row>
                        </template>
                    </vc-date-picker>
                </b-col>
                <b-col cols="3">
                    <b-button size="sm" block @click="setThisMonth" class="font-weight-bold cancel-button" variant="danger">
                        <i class="fa-regular fa-calendar-check mr-1"></i> This Month
                    </b-button>
                </b-col>
                <b-col cols="3">
                    <b-button size="sm" block @click="setLastMonth" class="font-weight-bold cancel-button" variant="danger">
                        <i class="fa-regular fa-calendar mr-1"></i>Last Month
                    </b-button>
                </b-col>
            </b-row>
            <div v-if="data == null" style="min-height: 200px; padding-top:80px;">
                <loading-spinner :busy="data == null"></loading-spinner>
            </div>
            <div v-else class="h-100">
                <b-row class="h-100">
                    <b-col>
                        <b-table-simple small borderless hover>
                            <b-thead head-variant="light">
                                <b-th>Day</b-th>
                                <b-th class="text-right text-black-50">Average</b-th>
                            </b-thead>
                            <b-tbody>
                         <template v-for="(item, i) in data" >
                             <b-tr :key="i" class="data">
                                <b-td class="data__title">{{ item.pushed_date | ucFirst }}:</b-td>
                                <b-td class="text-right font-weight-normal text-black-50">{{ item.avg_min_time_diff }}</b-td>
                             </b-tr>
                        </template>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </b-col>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import moment from 'moment';
    import LoadingSpinner from '../../../components/LoadingSpinner';
    export default {
        components: {LoadingSpinner, DateRangePicker},
        name: 'QaToOfferGen',
        props: {
            dataDisplay: {type:String,default: null},
            main_icon: {type:String,default:''},
            name: String,
            load_url: String,
            icons: Array,
            time_wait: { type: Number, default: 10000000 },
            title: String,
            bgColor: {type: String, default: 'light'},
        },
        data(){
            return {
                loading: false,
                expandGraphs: true,
                vipLeads: null,
                ncLeads: null,
                totalLeads: null,
                dateRange: {
                    start: null,
                    end: null
                },
                datePickerProps: {
                    placement: 'bottom',
                },
                modelConfig: {
                    start: {
                        timeAdjust: '00:00:00',
                    },
                    end: {
                        timeAdjust: '23:59:59',
                    },
                },
                chartData: {

                    datasets: [
                        {
                            data: [],
                            backgroundColor: ['#20a8d869', '#ffc40087'],
                            borderColor: ['#20a8d8', '#ffc400'],
                            borderWidth: 2
                        }
                    ],
                    labels: ['New', 'VIP'],

                    options: null,
                },
                hasAction: false,
                data: null,
            };
        },
        beforeDestroy(){
            clearInterval(this.interaval);
        },
        methods:{
            mountedAction() {
                this.setThisMonth();
            },
            formatDate(date_str){
                if (date_str) {
                    return moment(String(date_str)).format('MM/DD/YYYY');
                }
                return date_str;
            },
            getData: function () {

                let data = {
                    'start': this.formatDate(this.dateRange.start),
                    'end': this.formatDate(this.dateRange.end),
                };
                this.values = null;
                this.loading = true;
                this.$http.post('/dashboards/TimeToOffer/', data).then((data) => {
                    console.log(data);
                    this.data = [];
                    _.forEach(data.data.data, (value) => {
                        this.data.push(value);
                    });
                    this.loading = false;
                });
            },
            setThisMonth() {
                var date = new Date();
                this.dateRange.start = new Date(date.getFullYear(), date.getMonth(), 1);
                this.dateRange.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                this.getData();
            },
            setLastMonth() {
                var date = new Date();
                this.dateRange.start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
                this.dateRange.end = new Date(date.getFullYear(), date.getMonth(), 0);
                this.getData();
            },
            expandGraph() {
                let expandCard = document.querySelectorAll('.expand-card');
                expandCard.forEach(function (card) {
                    card.classList.remove('expand-graph');
                });
                this.expandGraphs = !this.expandGraphs;
            },
        },
        watch: {
            dateRange: function(val){
                this.getData();
            },
        }
    };

</script>


<style scoped>
    .merge-card {
        flex: 1;
        margin:0 1.5%;
    }

    .data {
        flex: 1;
        border-bottom: 1px solid #f4f4f4;
        margin-bottom: 2px
    }
    .data__title {
        font-weight: 400;
    }
    .data__num {
        float: right;
    }

    .display_on_top {
        z-index: 1000;
    }

    .card {
        flex: 1;
        /*margin: 0 8px;*/
        transition: .3s ease-in-out;
    }

    .card.expand-graph {
        flex: 5 !important;
    }
    .font-uppercase {
        text-transform: uppercase;
    }

</style>
